"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaControlState = exports.MediaType = void 0;
var MediaType;
(function (MediaType) {
    MediaType[MediaType["Audio"] = 0] = "Audio";
    MediaType[MediaType["Image"] = 1] = "Image";
    MediaType[MediaType["Video"] = 2] = "Video";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
var MediaControlState;
(function (MediaControlState) {
    MediaControlState[MediaControlState["Play"] = 0] = "Play";
    MediaControlState[MediaControlState["Pause"] = 1] = "Pause";
})(MediaControlState = exports.MediaControlState || (exports.MediaControlState = {}));
